(() => {
  const main = document.querySelector('#main');
  if (!main) return;
  const browseUrl = main.querySelector('[data-cw-search-fallback]')?.dataset.browseUrl;

  let menu;
  let signature = '';
  let scheduled = false;
  const sourceSelector = '#snize-modal-mobile-sortby-dialog .snize-main-panel-dropdown-content';

  const close = () => { if (menu) menu.open = false; };
  const update = () => {
    scheduled = false;
    const results = main.querySelector('#snize_results');
    // The app's empty-state reset repeats the original unsuccessful query.
    // Give this link a real, locale-aware collection destination instead.
    if (browseUrl) {
      results?.querySelectorAll('.snize-no-products-found a.snize-link-home').forEach((link) => {
        link.href = browseUrl;
        link.classList.replace('snize-link-home', 'cw-search-browse-link');
      });
    }
    const header = results?.querySelector(':scope > .snize-header');
    const nativeButton = results?.querySelector('.snize-main-panel-dropdown-button');
    const source = document.querySelector(sourceSelector);
    // A mobile-first Searchanise instance drops its toolbar when enlarged.
    // Leave every normal app toolbar alone and recover only that missing state.
    if (!header || !source || results.classList.contains('snize-mobile-design') ||
        results.classList.contains('snize-nothing-found') || nativeButton?.getClientRects().length) {
      menu?.remove();
      menu = null;
      signature = '';
      header?.classList.remove('cw-search-recovered-toolbar');
      return;
    }

    const options = [...source.querySelectorAll('a')];
    // Searchanise omits the configured default (newest first) and descending
    // order from its URL. Its hidden mobile list is stale in desktop mode.
    const params = new URLSearchParams(window.location.search);
    const selectedClass = `snize-main-panel-dropdown-${params.get('sort_by') || 'created'}-${params.get('sort_order') || 'desc'}`;
    const current = options.find((option) => option.classList.contains(selectedClass)) ||
      options.find((option) => option.getAttribute('aria-selected') === 'true');
    if (!current) return;
    const nextSignature = `${selectedClass}|${options.map((option) => `${option.className}:${option.textContent}`).join('|')}`;
    if (menu?.isConnected && signature === nextSignature) return;
    menu?.remove();
    signature = nextSignature;
    menu = document.createElement('details');
    menu.className = 'cw-search-resize-sort';
    const summary = document.createElement('summary');
    summary.textContent = current.textContent;
    const list = document.createElement('ul');
    list.className = 'snize-main-panel-dropdown-content';
    options.forEach((option) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#';
      link.className = option.className;
      link.classList.remove('current');
      link.textContent = option.textContent;
      if (option === current) { link.classList.add('current'); link.setAttribute('aria-current', 'true'); }
      const sortClass = [...option.classList].find((name) => name.startsWith('snize-main-panel-dropdown-'));
      link.addEventListener('click', (event) => {
        event.preventDefault();
        close();
        summary.focus();
        // Delegate to the app's current option, including its existing filter
        // and pagination handling. No second search implementation or API.
        const nativeOption = [...document.querySelectorAll(`${sourceSelector} a`)]
          .find((candidate) => candidate.classList.contains(sortClass));
        nativeOption?.click();
      });
      item.append(link);
      list.append(item);
    });
    menu.append(summary, list);
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); summary.focus(); }
    });
    header.classList.add('cw-search-recovered-toolbar');
    header.append(menu);
  };

  const schedule = () => {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
  };
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('click', (event) => {
    if (menu && !menu.contains(event.target)) close();
  });
  update();
})();
